// SPDX-License-Identifier: AGPL-3.0-or-later

import CompanionSessionStore from '@app/features/companion/state/CompanionSessionStore';
import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';

interface CompanionSuggestionPayload {
	session_id: string;
	suggestion_id: string;
	kind: string;
	text: string;
	created_at: string;
}

export function handleCompanionSuggestion(data: CompanionSuggestionPayload, _context: GatewayHandlerContext): void {
	CompanionSessionStore.handleSuggestion(data);
}
